import { createBrowserRouter, Navigate } from "react-router-dom";
import { ProjectsList } from "../pages/ProjectsList";
import { ProjectShell } from "../project/ProjectShell";

export const router = createBrowserRouter([
  { path: "/", element: <Navigate to="/projects" replace /> },
  { path: "/login", element: <Navigate to="/projects" replace /> },
  { path: "/projects", element: <ProjectsList /> },
  { path: "/projects/:id", element: <ProjectShell /> },
  { path: "/projects/:id/step/:n", element: <ProjectShell /> },
  { path: "*", element: <Navigate to="/projects" replace /> },
]);
